import {getUserBYId, getUserInfo, getUsers} from "../../api/userService";
import {getLastTimes} from "@/api/listTime";

const state = () => ({
    user_profile: {},
    user_detail: {},
    usersList: [],
    selectedUser: {},
    lastTime: {},
    lastTimeUser: {}
})

const getters = {
    getUserProfile(state) {
        return state.user_profile;
    },
    getUserDetail(state){
        return state.user_detail
    },
    getUsers(state){
        return state.usersList
    },
    getSelectedUser(state){
        return state.selectedUser
    },
    getLastTime(state){{
        return state.lastTime
    }},
    getLastTimeUser(state){{
        return state.lastTimeUser
    }}
}

const mutations = {
    SET_USER_INFO(state, info) {
        state.user_profile = info
    },
    SET_USER_DETAIL (state, data){
        state.user_detail = data
    },
    SET_USERS_LIST (state, data){
        state.usersList = data
    },
    SET_SELECTED_USER (state, data){
        state.selectedUser = data;
    },
    SET_LASTTIME (state, data){
        state.lastTime = data
    },
    SET_LASTTIMEUSER (state, data){
        state.lastTimeUser = data
    }

}

const actions = {
    async fetchUserInfo ({commit}) {

        // eslint-disable-next-line no-useless-catch
        try {
            let resp = await getUserInfo();
            commit('SET_USER_INFO', resp.data);
        } catch (e) {
            throw e
        }
    },
    async fetchUserDetail ({commit}, id){
        try {
            let resp = await getUserBYId(id);
            commit('SET_USER_DETAIL', resp.data);
        } catch (e) {
            //
        }
    },
    async fetchUsersList( {commit}, params) {
        try {
            let resp = await getUsers(params);
            commit('SET_USERS_LIST', resp.data);
        } catch (e) {
            //
        }
    },
    async selectedUser({commit}, id){
        try {
            let resp = await getUserBYId(id);
            commit('SET_SELECTED_USER', resp.data);
        } catch (e) {
            //
        }
    },
    async fetchLastTime({commit}, params){
        try {
            
            let resp = await getLastTimes(params);

            commit('SET_LASTTIME', resp.data);
        } catch (e) {
            console.log(e);
        }
    },
    async fetchLastTimeUser({commit}, params){
        try {
            console.log(params);

            let resp = await getLastTimes(params);

            commit('SET_LASTTIMEUSER', resp.data);
        } catch (e) {
            console.log(e);
        }
    }

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

